<template>
  <div id="home">
    <div class="container content-section services-top">
      <div class="services-intro">
        <p class="services-eyebrow">Our Services</p>
        <h2>Thoughtful web experiences for every stage of growth.</h2>
        <p class="services-intro-copy">
          From custom design to responsive development, we build sites that look
          sharp, communicate clearly, and help your business stand out.
        </p>
      </div>
    </div>

    <div class="hero-section">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7">
            <div class="hero-copy-card">
              <p class="eyebrow">Professional web design and development</p>
              <h1>Modern websites built to grow your business.</h1>
              <p class="lead">
                IMEJ Tech creates polished, responsive websites for professionals,
                creatives, and growing companies who want a stronger online presence.
              </p>
              <h4>What We Offer</h4>
              <ul>
                <li>Custom website design and development</li>
                <li>Responsive layouts for mobile and desktop</li>
                <li>WordPress, Squarespace, or custom-built solutions</li>
                <li>Ongoing support and maintenance</li>
              </ul>
            </div>
            <div class="hero-actions">
              <router-link to="/Contact" class="btn btn-primary btn-lg"
                >Book a Free Consultation</router-link>
              <router-link to="/Portfolio" class="btn btn-primary btn-lg portfolio-btn">View Portfolio</router-link>              
            </div>
            <br>
          </div>
        </div>
      </div>
    </div>

    <div class="container content-section">
      <div class="services-grid">
        <div class="row">
          <div class="col-md-6 col-lg-3 mb-4">
            <div class="service-card">
              <img src="../assets/ai-pic4.png" alt="Website design" />
              <h4>Custom Design</h4>
              <p>Clean layouts and thoughtful structure that reflect your brand.</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-4">
            <div class="service-card">
              <img src="../assets/ai-pic3.png" alt="Responsive development" />
              <h4>Responsive Development</h4>
              <p>Websites that look polished and perform well on every device.</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-4">
            <div class="service-card">
              <img src="../assets/ai-pic5.png" alt="Website platforms" />
              <h4>Platform Flexibility</h4>
              <p>Built from scratch, on Squarespace, or on WordPress based on your needs.</p>
            </div>
          </div>
          <div class="col-md-6 col-lg-3 mb-4">
            <div class="service-card">
              <img src="../assets/screen-3.png" alt="Consultation" />
              <h4>Strategic Support</h4>
              <p>Clear guidance from discovery through launch and beyond.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
    msg: String,
  },
};
</script>

<style scoped>
#home {
  position: relative;
  display: flex;
  flex-direction: column;
  background: #0b1020;
  overflow: hidden;
}

#home::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("../assets/screen-5.png");
  background-size: cover;
  background-position: center;
  filter: blur(3px) brightness(0.7);
  transform: scale(1.08);
  z-index: 0;
}

#home > * {
  position: relative;
  z-index: 1;
}
.hero-section {
  text-align: center;
  padding: 28px 0 24px;
  color: white;
  background: linear-gradient(120deg, rgba(2, 8, 23, 0.62), rgba(15, 23, 42, 0.2));
}
.hero-section .row {
  justify-content: center;
}
.hero-section .col-lg-7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.hero-copy-card {
  text-align: center;
  display: inline-block;
  width: 100%;
  max-width: 760px;
  background: rgba(2, 8, 23, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 16px;
  padding: 16px 20px;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.24);
  backdrop-filter: blur(6px);
}
.hero-copy-card ul {
  display: inline-block;
  margin: 0 auto;
  padding-left: 1.2rem;
  text-align: left;
}

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: #dfe9ff;
}
h1 {
  font-size: clamp(1.4rem, 2vw, 1.9rem);
  font-weight: 700;
  margin-bottom: 10px;
  line-height: 1.2;
}
.lead {
  font-size: 0.95rem;
  max-width: 680px;
  line-height: 1.6;
  color: #f8fbff;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.42);
  font-weight: 500;
  letter-spacing: 0.01em;
  padding: 0.4rem 0;
  margin-bottom: 0;
}
.hero-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
}
.hero-actions .btn {
  border-radius: 999px;
  padding: 0.6rem 0.9rem;
  font-weight: 600;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.16);
}
.info-card,
.service-card {
  background: rgba(10, 24, 44, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 18px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-card:hover,
.service-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 44px rgba(0, 0, 0, 0.26);
}
.info-card {
  padding: 16px;
}
.info-card h3 {
  font-size: 1.05rem;
  margin-bottom: 10px;
  color: white;
}
.info-card ul {
  padding-left: 18px;
  margin: 0;
  color: #e6ebf8;
  line-height: 1.7;
}
.content-section {
  padding: 0 0 28px;
}

.services-top {
  padding-top: 20px;
  padding-bottom: 8px;
}

.services-intro {
  text-align: center;
  max-width: 700px;
  margin: 0 auto 14px;
  color: white;
}

.services-eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.24em;
  font-size: 0.72rem;
  font-weight: 700;
  color: #b7c7f8;
  margin-bottom: 8px;
}

.services-intro h2 {
  font-size: clamp(1.05rem, 1.6vw, 1.35rem);
  font-weight: 700;
  margin-bottom: 6px;
  color: #ffffff;
}

.services-intro p {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #e8eefc;
  margin-bottom: 0;
}

.services-intro-copy {
  font-size: 1rem;
  line-height: 1.75;
  color: #f4f7ff;
  max-width: 650px;
  margin: 0 auto;
  font-weight: 500;
}
.service-card {
  height: 100%;
  overflow: hidden;
  padding-bottom: 2px;
}
.service-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}
.service-card h4 {
  padding: 12px 12px 4px;
  color: white;
  font-size: 1rem;
  font-weight: 700;
}
.service-card p {
  padding: 0 12px 12px;
  color: #dfe6f7;
  line-height: 1.5;
}
.portfolio-btn {
  background-color: #007bff;
  border-color: #007bff;
  color: #ffffff;
}

.portfolio-btn:hover,
.portfolio-btn:focus {
  background-color: #0069d9;
  border-color: #0062cc;
  color: #ffffff;
}
@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
